export default {
  app: {
    title: "Caja de vocabulario de ensueño",
    language: "Español"
  },

  pages: {
    app: {
      myAccount: "Mi cuenta",
      editProfile: "Editar perfil",

      boxScenarios: "Escenarios de cajas",
      scenario1Title: "Caja de medio día",
      scenario1Desc: "Revisa la caja cada medio día (por ejemplo, mañana y tarde).",

      scenario2Title: "Caja diaria",
      scenario2Desc: "Revisa la caja una vez al día.",

      scenario3Title: "Días según número de caja",
      scenario3Desc: "Revisa la caja según su número (por ejemplo, Caja 3 cada 3 días).",

      username: "Nombre de usuario",
      usernameHint: "Tu nombre de usuario único para iniciar sesión",

      name: "Nombre",
      nameHint: "¿Cómo deberíamos llamarte?",

      email: "Correo electrónico",
      emailHint: "Correo para recuperar la contraseña (opcional)",

      changePassword: "Cambiar contraseña",
      changePasswordHint: "Si no deseas cambiar la contraseña, deja este campo vacío (opcional)",

      logout: "Cerrar sesión",
      confirmLogout: "Confirmar cierre de sesión",
      confirmLogoutText: "¿Seguro que quieres cerrar sesión?",
      cancel: "Cancelar",

      close: "Cerrar",
      updateProfile: "Actualizar perfil",

      myWords: "Mis palabras",
      addNewWord: "Añadir nueva palabra / expresión",
      boxes: "Cajas",

      applicationSettings: "Configuración de la aplicación",

      autoSpeechOnChecking: "Reproducir la palabra automáticamente al mostrarse",
      autoDetectClipboardChange: "Detectar texto del portapapeles automáticamente",

      clipboardPermissionText: "La aplicación necesita permiso para acceder al portapapeles en la configuración del navegador. Para más ayuda, haz clic aquí.",

      clipboardHelpTitle: "Cómo habilitar el acceso al portapapeles",

      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",

      chromeStep1: "Abre el navegador Chrome.",
      chromeStep2: "Ve a la configuración del navegador.",
      chromeStep3: "Busca la sección Configuración del sitio.",
      chromeStep4: "Entra en Permisos y habilita Portapapeles.",

      firefoxStep1: "Abre el navegador Firefox.",
      firefoxStep2: "Ve a Configuración del navegador.",
      firefoxStep3: "Busca la sección Permisos y habilita el acceso al portapapeles.",

      safariStep1: "Abre la aplicación Ajustes de tu teléfono.",
      safariStep2: "Ve a Safari.",
      safariStep3: "Busca las opciones relacionadas con el portapapeles y actívalas.",

      otherBrowserTitle: "Si usas otro navegador",
      otherBrowserStep1: "Busca una opción similar de Permisos o Configuración del sitio en el navegador y habilita el acceso al portapapeles.",

      speechNotSupported: "Tu navegador no soporta SpeechSynthesis",

      ttsSettings: "Configuración de texto a voz",
      sampleText: "Texto para probar la voz",

      rate: "Velocidad",
      rateHint: "Controla la velocidad del habla.",

      pitch: "Tono",
      pitchHint: "Ajusta el tono de la voz.",

      volume: "Volumen",
      volumeHint: "Establece el volumen de la voz.",

      friends: "Amigos",
      messages: "Mensajes",

      addToMyWords: "Añadir {word} a mis palabras",
      viewInMyList: "Ver {word} en mi lista",

      wordSuggestion: "Sugerencia de palabra",
      goToAddWord: "Ir a añadir nueva palabra",

      updateCompleted: "Actualización completada correctamente",
      latestChanges: "Últimos cambios en versiones recientes",
      version: "Versión",
      gotIt: "Entendido"
    },

    addVocabulary: {
      title: "Añadir nueva palabra",
      add: "Añadir",
      word: "Palabra / frase",
      meaning: "Significado",
      example: "Ejemplo",
      description: "Descripción"
    },

    vocabularies: {
      searchLabel: "Buscar texto",
      listLength: "Longitud de lista",
      boxNumber: "Número de caja",
      nothingFound: "No se encontró nada",
      adjustFilters: "Intenta ajustar los filtros",
      tableWord: "Palabra",
      tableAction: "Acción",
      showDetails: "Mostrar detalles",
      completeInfo: "Información completa",
      meaning: "Significado",
      example: "Ejemplo",
      description: "Descripción",
      close: "Cerrar",
      editTitle: "Editar",
      editBtn: "Editar",
      deleteTitle: "Eliminar {word}",
      deleteConfirmText: "¿Seguro que deseas eliminar esta palabra? Una vez eliminada no se puede restaurar.",
      yes: "Sí",
      no: "No"
    },

    messages: {
      wordSuggestions: "Sugerencias de palabras"
    },

    login: {
      signInTitle: "Iniciar sesión",
      signInBtn: "Entrar",
      registerTitle: "Registrarse",
      registerBtn: "Registrarse",
      registerLink: "Registrarse",
      username: "Nombre de usuario",
      password: "Contraseña",
      nickname: "Nombre",
      email: "Correo electrónico",
      noAccount: "¿Aún no te has registrado?",
      haveAccount: "Ya tengo una cuenta.",
      usernameHint: "Tu nombre de usuario único para iniciar sesión",
      nicknameHint: "¿Cómo deberíamos llamarte?",
      emailHint: "Correo para recuperar la contraseña (opcional)",
      passwordHint: "Contraseña sin reglas, escribe lo que quieras",
      orContinueWith: "O continuar con...",
      guestRegister: "Registro rápido como invitado 😒"
    },

    reviewVocabulary: {
      showMeaning: "Mostrar significado",
      hideMeaning: "Ocultar significado",
      meaning: "Significado",
      example: "Ejemplo",
      description: "Descripción",
      playPhrase: "PlayPhrase.me",
      prev: "Anterior",
      next: "Siguiente"
    },

    checkVocabulary: {
      showMeaning: "Mostrar significado",
      hideMeaning: "Ocultar significado",
      wordsRemain: "Palabras restantes",
      lastOne: "Última",
      meaning: "Significado",
      example: "Ejemplo",
      description: "Descripción",
      playPhrase: "PlayPhrase.me",
      iRemember: "Lo recuerdo",
      iDontRemember: "No lo recuerdo"
    },

    boxes: {
      all: "Mostrar todas las cajas",
      box: "Caja",
      empty: "Vacía",
      needsChecking: "Necesita revisión",
      checked: "Revisado",

      total: "Total",
      waiting: "En espera",
      waitingForCheck: "Esperando revisión",

      closestReview: "Próxima revisión",
      notScheduled: "Aún no programado",

      deeplyMemorized: "Has memorizado profundamente {count} palabras.",
      notReachedYet: "¡Aún no has llegado a esta caja!",

      startChecking: "Empezar revisión",
      review: "Revisar",
      viewAllWords: "Ver todas las palabras",
      addNew: "Añadir nueva",
      itsEmpty: "Está vacía"
    },

    friends: {
      searchInUsers: "Buscar usuarios",
      searchList: "Lista de búsqueda",
      noUsersYet: "Aún no hay usuarios.",
      searchUsersAndSendRequest: "Puedes buscar usuarios y enviar solicitudes de amistad",
      friendList: "Lista de amigos",
      noFriendsYet: "Aún no tienes amigos."
    }
  },

  plugins: {
    axios: {
      postRequestError: "Error al enviar la solicitud"
    }
  },

  components: {
    shareButton: {
      shareTitle: "Compartir {word}",
      messageOptional: "Mensaje (opcional)"
    },

    userList: {
      cancelRequest: "Cancelar solicitud",
      unfriend: "Eliminar amigo",
      sendRequest: "Enviar solicitud",
      accept: "Aceptar",
      reject: "Rechazar",

      share: "Compartir",
      addedBefore: "Añadido anteriormente",

      deeplyMemorized: "{name} ha memorizado profundamente {count} palabras.",
      notReachedBox: "{name} aún no ha llegado a esta caja.",

      totalVocabularies: "Total de vocabularios",
      registerAge: "Antigüedad de registro",
      lastCheck: "Última revisión",
      lastAddedVocabulary: "Última palabra añadida",
      totalChecks: "Total de revisiones",
      averageDailyCheck: "Promedio diario de revisiones",
      averageDailyLearnedCheck: "Promedio diario de revisiones aprendidas",
      averageDailyNotLearnedCheck: "Promedio diario de revisiones no aprendidas",
      averageDailyAdd: "Promedio diario de añadidos"
    }
  },

  public: {
    close: "Cerrar"
  },
  "apiResultStatusCodes": {
    "0": "La operación falló",
    "1": "Operación exitosa",
    "2": "Ocurrió un error",
    "3": "Parámetros enviados inválidos",
    "4": "No encontrado",
    "5": "Error de autenticación",
    "6": "Este elemento ya ha sido registrado",
    "7": "Este usuario ya ha sido registrado",
    "8": "El usuario especificado no existe",
    "9": "Contraseña incorrecta",
    "10": "Parámetros inválidos",
    "11": "Error de inicio de sesión",
    "12": "Acceso denegado",
    "13": "Elemento no encontrado",
    "14": "Este nombre de usuario ya está en uso",
    "15": "Este correo electrónico ya está en uso",
    "16": "El nombre de usuario es obligatorio",
    "17": "El apodo es obligatorio",
    "18": "La contraseña es obligatoria",
    "19": "El nombre de usuario no puede contener espacios",
    "20": "Registro completado con éxito",
    "21": "Inicio de sesión exitoso",
    "22": "La contraseña no puede contener espacios",
    "23": "Vocabulario agregado correctamente",
    "24": "Vocabulario actualizado correctamente",
    "25": "Vocabulario eliminado correctamente",
    "26": "Ya has agregado este vocabulario",
    "27": "La palabra es obligatoria",
    "28": "No se encontró vocabulario",
    "29": "¡Felicidades! Todas las palabras en esta caja han sido revisadas",
    "30": "No puedes cambiar el campo de palabra",
    "31": "Por favor completa los campos obligatorios",
    "32": "No se encontraron cambios",
    "33": "El usuario especificado no existe en el repositorio",
    "34": "Solicitud de amistad enviada correctamente",
    "35": "Solicitud de amistad aceptada correctamente",
    "36": "Solicitud de amistad cancelada correctamente",
    "37": "Has eliminado la amistad correctamente",
    "38": "Has rechazado la solicitud correctamente",
    "39": "Mensaje enviado correctamente"
  },
  "time": {
    "day": "día | días",
    "hour": "hora | horas",
    "minute": "minuto | minutos"
  }


}
